import { useEffect, useState } from 'react';
import { EasterTheme, getEasterTheme } from '../../utils/easterTheme';

const ONE_MINUTE = 60 * 1000;

const useEasterTheme = (): EasterTheme => {
  const [theme, setTheme] = useState<EasterTheme>(() => getEasterTheme());

  useEffect(() => {
    const interval = window.setInterval(() => {
      setTheme(getEasterTheme());
    }, ONE_MINUTE);

    return () => window.clearInterval(interval);
  }, []);

  return theme;
};

export default useEasterTheme;
